(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wristly-home-signal"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root) return;
    var stage = root.querySelector('.signal-stage');
    var vA = root.querySelector('.signal-video-a');
    var vB = root.querySelector('.signal-video-b');
    var readout = root.querySelector('.signal-readout');
    var feelBtn = root.querySelector('.cue-btn-feel');
    var current = vA, next = vB;
    var swapping = false;

    function pulse(){
      if(!stage) return;
      stage.classList.remove('is-pulsing');
      void stage.offsetWidth;
      stage.classList.add('is-pulsing');
      if(readout) readout.textContent = 'Signal felt · 0 dB';
    }

    if(feelBtn){
      feelBtn.addEventListener('click', function(e){
        e.preventDefault();
        pulse();
        var href = feelBtn.getAttribute('href');
        window.setTimeout(function(){ window.location.href = href; }, 360);
      });
    }

    function attemptPlay(v){
      var p = v.play();
      if(p && p.catch) p.catch(function(){
        document.addEventListener('click', function once(){ v.play().catch(function(){}); document.removeEventListener('click', once); }, { once: true });
      });
    }

    function crossfadeCheck(){
      if(swapping || !current.duration || isNaN(current.duration)) return;
      if(current.currentTime >= current.duration - 0.12){
        swapping = true;
        next.currentTime = 0;
        attemptPlay(next);
        next.classList.add('is-active');
        current.classList.remove('is-active');
        var prev = current;
        current = next;
        next = prev;
        window.setTimeout(function(){
          next.pause();
          next.currentTime = 0;
          swapping = false;
        }, 380);
      }
    }

    if(vA && vB){
      vA.addEventListener('timeupdate', crossfadeCheck);
      vB.addEventListener('timeupdate', crossfadeCheck);
      attemptPlay(vA);
    }
  }

  document.querySelectorAll('.signal-cinema').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
